/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/** Copies text to the clipboard; a refused copy (no permission, old browser) is ignored. */
export const copyText = (text) => navigator.clipboard?.writeText(text).catch(() => {});

/**
 * "2026-10-24" -> "Oct 24" (UTC), so day labels fit without slanting. A note after the date is kept
 * ("2026-11-03 (so far)" -> "Nov 3 (so far)"). Other labels are kept as they are.
 */
export const shortDayLabel = (label) => {
  const day = /^(\d{4}-\d{2}-\d{2})(?:[T ]00:00(?::00)?(?:\.000)?Z?)?(\s+\(.*\))?$/.exec(String(label));
  if (!day) return label;
  const date = new Date(`${day[1]}T00:00:00Z`).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC'
  });
  return day[2] ? `${date}${day[2]}` : date;
};
